import { IAppState } from '../../../AppModulesWrapper';

export function selectMinimalBet(state: IAppState): number {
  return state.servicePickerWidget.auction.minimalBet;
}
